import React, { useState } from "react";

import { useGetSearchWorkOrders } from "../../hooks";
import { HubHookFormSearchField } from "../HubHookFormSearchField";
import WorkOrderResultItem from "./WorkOrderResultItem";

export const HubHookFormWorkOrderSelect = ({
  name = "workOrder",
  label = "Work Order",
  placeholder = "Search Work Order...",
  defaultValue,
  ...rest
}) => {
  const [value, setValue] = useState();
  const { data } = useGetSearchWorkOrders(value, defaultValue);

  return (
    <HubHookFormSearchField
      name="workOrder"
      label="Work Order"
      placeholder="Search Work Order..."
      optionIdKey="label"
      defaultValue={defaultValue}
      options={data || []}
      value={value}
      setValue={setValue}
      RenderInput={WorkOrderResultItem}
      RenderOption={WorkOrderResultItem}
      {...rest}
    />
  );
};

export default HubHookFormWorkOrderSelect;
